import {RouteConfig} from "vue-router";
import Error404 from "@/views/errors/404.vue";

// MasterLayout
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";

// Register
import registerRoutes from "./register";
import defaultRoutes from "./default";
import departmentRoutes from "./department";
import serviceRoutes from "./services";
import Home from "@/views/Home.vue";
import organizationRoutes from "./organization";
import permissionRoutes from "./permission";
import rolesRoutes from "./roles";
import reportRoutes from "./report";
import customRoutesPermissionRoutes from "./customRoutesPermission";
import databaseConnectionRoutes from "./databaseConnection";

// CBS Routes
import CBSAPIGatewayRoutes from "./CBSApiGateway"
import CBSAccountingRoutes from "./CBSAccounting"
import CBSCommissionRoutes from "./CBSCommission"
import CBSPaymentRoutes from "./CBSPayment"
import CBSProductRoutes from "./CBSProduct"
import operationalLogs from "./operational_logs"
import CBSProductRatingRoutes from "./CBSProductRating"
import CBSUserManagementRoutes from "./CBSUserManagement"
import CBSSubscriptionRoutes from "./CBSSubscription"
import CBSInvoice from "./CBSInvoice"

// @ts-ignore
const baseRoutes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin",
    name: "AdminHome",
    component: Home,
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users",
    name: "Users",
    component: () => import("../views/User/UserList.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/add",
    name: "UserAdd",
    component: () => import("../views/User/UserForm.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/edit/:id",
    name: "UserEdit",
    component: () => import("../views/User/UserForm.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/view/:id",
    name: "UserView",
    component: () => import("../views/User/UserView.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/profile",
    name: "AuthProfile",
    component: () => import("../views/User/AuthProfile.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/notifications",
    name: "AuthNotifications",
    component: () => import("../views/User/AuthNotifications.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/notifications/:id/show",
    name: "AuthNotificationShow",
    component: () => import("../views/User/AuthNotificationShow.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/update-password",
    name: "AuthChangePassword",
    component: () => import("../views/User/UpdatePassword.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/ext/change-password",
    name: "UserPasswordReset",
    component: () => import("../views/User/UserPasswordReset.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },

  {
    path: "/admin/divisions",
    name: "DivisionList",
    component: () => import("../views/Division/DivisionList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/divisions/add",
    name: "DivisionAdd",
    component: () => import("../views/Division/DivisionForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/divisions/:id/edit",
    name: "DivisionEdit",
    component: () => import("../views/Division/DivisionForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/divisions/:id/show",
    name: "DivisionShow",
    component: () => import("../views/Division/DivisionShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/districts",
    name: "DistrictList",
    component: () => import("../views/District/DistrictList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/districts/add",
    name: "DistrictAdd",
    component: () => import("../views/District/DistrictForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/districts/:id/edit",
    name: "DistrictEdit",
    component: () => import("../views/District/DistrictForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/districts/:id/show",
    name: "DistrictShow",
    component: () => import("../views/District/DistrictShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/upazilas",
    name: "UpazilaList",
    component: () => import("../views/Upazila/UpazilaList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/upazilas/add",
    name: "UpazilaAdd",
    component: () => import("../views/Upazila/UpazilaForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/upazilas/:id/edit",
    name: "UpazilaEdit",
    component: () => import("../views/Upazila/UpazilaForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/upazilas/:id/show",
    name: "UpazilaShow",
    component: () => import("../views/Upazila/UpazilaShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaigns",
    name: "CampaignList",
    component: () => import("../views/Campaign/CampaignList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaigns/add",
    name: "CampaignAdd",
    component: () => import("../views/Campaign/CampaignForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaigns/:id/edit",
    name: "CampaignEdit",
    component: () => import("../views/Campaign/CampaignForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaigns/:id/show",
    name: "CampaignShow",
    component: () => import("../views/Campaign/CampaignShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaigns/:id/stats",
    name: "CampaignStats",
    component: () => import("../views/Campaign/CampaignStats.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaign_view_logs",
    name: "CampaignViewLogList",
    component: () => import("../views/CampaignViewLog/CampaignViewLogList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaign_view_logs/add",
    name: "CampaignViewLogAdd",
    component: () => import("../views/CampaignViewLog/CampaignViewLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaign_view_logs/:id/edit",
    name: "CampaignViewLogEdit",
    component: () => import("../views/CampaignViewLog/CampaignViewLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaign_view_logs/:id/show",
    name: "CampaignViewLogShow",
    component: () => import("../views/CampaignViewLog/CampaignViewLogShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaign_click_logs",
    name: "CampaignClickLogList",
    component: () => import("../views/CampaignClickLog/CampaignClickLogList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaign_click_logs/add",
    name: "CampaignClickLogAdd",
    component: () => import("../views/CampaignClickLog/CampaignClickLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaign_click_logs/:id/edit",
    name: "CampaignClickLogEdit",
    component: () => import("../views/CampaignClickLog/CampaignClickLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/campaign_click_logs/:id/show",
    name: "CampaignClickLogShow",
    component: () => import("../views/CampaignClickLog/CampaignClickLogShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/generate-ads-code",
    name: "generateAdsCode",
    component: () => import("../views/GenerateAdsCode/index.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    }
  },
  {
    path: "/admin/zones",
    name: "ZoneList",
    component: () => import("../views/Zone/ZoneList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/zones/add",
    name: "ZoneAdd",
    component: () => import("../views/Zone/ZoneForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/zones/:id/edit",
    name: "ZoneEdit",
    component: () => import("../views/Zone/ZoneForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/zones/:id/show",
    name: "ZoneShow",
    component: () => import("../views/Zone/ZoneShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/mac_addresses",
    name: "MacAddressList",
    component: () => import("../views/MacAddress/MacAddressList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/mac_addresses/add",
    name: "MacAddressAdd",
    component: () => import("../views/MacAddress/MacAddressForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/mac_addresses/:id/edit",
    name: "MacAddressEdit",
    component: () => import("../views/MacAddress/MacAddressForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/mac_addresses/:id/show",
    name: "MacAddressShow",
    component: () => import("../views/MacAddress/MacAddressShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/user_details",
    name: "UserDetailList",
    component: () => import("../views/UserDetail/UserDetailList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/user_details/add",
    name: "UserDetailAdd",
    component: () => import("../views/UserDetail/UserDetailForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/user_details/:id/edit",
    name: "UserDetailEdit",
    component: () => import("../views/UserDetail/UserDetailForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/user_details/:id/show",
    name: "UserDetailShow",
    component: () => import("../views/UserDetail/UserDetailShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  //##Routes##//
];

const routes = baseRoutes.concat(
  registerRoutes,
  defaultRoutes,
  departmentRoutes,
  serviceRoutes,
  organizationRoutes,
  permissionRoutes,
  rolesRoutes,
  operationalLogs,
  reportRoutes,
  customRoutesPermissionRoutes,
  databaseConnectionRoutes,

  // CBS Routes
  CBSAPIGatewayRoutes,
  CBSAccountingRoutes,
  CBSCommissionRoutes,
  CBSPaymentRoutes,
  CBSProductRoutes,
  CBSProductRatingRoutes,
  CBSUserManagementRoutes,
  CBSSubscriptionRoutes,
  CBSInvoice
)

export default routes
